import { Component, type ErrorInfo, type ReactNode } from 'react'

/**
 * Fängt einen Absturz beim Zeichnen ab, statt das ganze Admin zu verlieren.
 * Ohne sie riss ein Fehler in einer Seite die ganze Oberfläche mit — übrig
 * blieb ein schwarzes Bild, bis man neu lud (gemeldet am 05.10.). Jetzt
 * bleiben Navigation und die anderen Seiten bedienbar, und die Meldung steht
 * da, wo sonst die Seite wäre — damit sich der Fehler finden lässt.
 *
 * `key` am Aufrufer (der Bereich) setzt sie beim Seitenwechsel zurück.
 */
export class Fehlergrenze extends Component<
  { children: ReactNode; ganzeSeite?: boolean },
  { fehler: Error | null }
> {
  override state: { fehler: Error | null } = { fehler: null }

  static getDerivedStateFromError(fehler: Error) {
    return { fehler }
  }

  override componentDidCatch(fehler: Error, info: ErrorInfo) {
    console.error('Admin: Seite abgestürzt', fehler, info.componentStack)
  }

  override render() {
    const { fehler } = this.state
    if (!fehler) return this.props.children
    return (
      <div
        role="alert"
        className={`card space-y-3 p-6 ${this.props.ganzeSeite ? 'm-4 sm:m-8' : ''}`}
      >
        <p className="font-semibold text-status-error">Diese Seite ist abgestürzt.</p>
        <p className="text-sm text-text-muted">
          Neu laden hilft meist. Wenn es wieder passiert, bitte diese Meldung weitergeben:
        </p>
        <pre className="overflow-x-auto whitespace-pre-wrap rounded-xl bg-surface-2 p-3 font-mono text-xs text-text">
          {fehler.name}: {fehler.message}
        </pre>
        <button type="button" className="btn-primary" onClick={() => window.location.reload()}>
          Neu laden
        </button>
      </div>
    )
  }
}
